import { ChangeDetectionStrategy, Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogRef } from '@angular/material/dialog';
import { IOptions, IPreferences, IResponse } from '@interfaces/index';
import { PreferenceService } from '@ui-components/services/preference.service';

@Component({
  selector: 'lib-preferences-modal',
  templateUrl: './preferences-modal.component.html',
  styleUrl: './preferences-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LibPreferencesModalComponent {

  loading = false;
  options: IOptions[] = [];
  preferences: IPreferences[] = [];

  constructor(
    protected _preference_service: PreferenceService,
    protected _dialog_ref: MatDialogRef<LibPreferencesModalComponent>,
    private _destroy_ref: DestroyRef
  ) {}

  ngOnInit() {
    this.loading = true;
    this._preference_service.getPreferences()
      .pipe(takeUntilDestroyed(this._destroy_ref))
      .subscribe(
        (response: IResponse<IPreferences[]>) => {
          this.preferences = response.data;
          response.data.forEach(option => {
            this.options.push(...option.preferences)
          });
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      )
  }

  preferenceSelection(selectedOption: IOptions) {
    if (!this.preferences[0].has_assessment && selectedOption.option_id === 1) {
      return;
    }
    this.options.forEach(option => {
      option.value = (option.option_id === selectedOption.option_id)
    });
  }

  saveSelection(): void {
    const preferences = this.options.map(option => ({
      option_id: option.option_id,
      value: option.value
    })
    );
    this._preference_service.savePreferences(preferences)
      .pipe(takeUntilDestroyed(this._destroy_ref))
      .subscribe(
        () => {
          this.loading = false;
          this._dialog_ref.close(true);
        },
        () => {
          this.loading = false;
        }
      );
  }

}
